import { createFileRoute } from "@tanstack/react-router";
import { SalesBoardPage } from "@/features/sales/SalesBoardPage";

export const Route = createFileRoute("/_app/sales/")({
  component: () => <SalesBoardPage />,
});
